import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ToolbarService,GroupService, GridComponent, PdfExportService, PdfExportProperties } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

@Component({
  selector: 'app-recruiting',
  templateUrl: './recruiting.component.html',
  styleUrls: ['./recruiting.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService,PdfExportService]
})
export class RecruitingComponent implements OnInit {
  @ViewChild('grid') public grid: any;
  recruitingdaevadere:any[]=[];
  public toolbar: string[];


  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }

  ngOnInit(): void {
  //  this.toolbar = ['Search','PdfExport'];
    this.toolbar = ['Search'];
    

    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/recruitingdaevadere',params).subscribe(dataag => {
        this.recruitingdaevadere=dataag.Result;
        this.grid.localeObj.currentLocale.EmptyRecord = 'Nessun dato da visualizzare ...'; 
      });
    });
  }
  onLoad() { 
    this.grid.localeObj.currentLocale.EmptyRecord = 'Caricamento in corso...'; 
  }

  goto(){
    this.router.navigateByUrl('/java/assunzioni/login/LogonServletAs?oper=1'.replace('?','QUESTION').replace('=','UGUAL'));
    
  }

  toolbarClick(args: ClickEventArgs): void {
    console.log((this.grid as GridComponent).columns[6]);
      const pdfExportProperties: PdfExportProperties = {
        pageSize: 'A4',
        pageOrientation:'Portrait'
    };
    (this.grid as GridComponent).pdfExport(pdfExportProperties);
    
  }

  apri(data){
 
    if(data.modulo=='recruiting'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('assunzioni/login/LogonServletAs?oper=7&timbro='+data.id,'POST',params);
    }

  
    
  }
}
